import PropTypes from "prop-types"
import { compose, withHandlers } from "recompact"
import { withPropsOnChange } from "recompose"
import hocInterface from "src/helpers/hocInterface"
import { prepareCalendarData } from "../helpers/prepareCalendarData"

/**
 * Создает и кеширует данные для календаря на основе данных от бека
 */
export default hocInterface(
  {
    injectProps: {
      planId: PropTypes.string,
      calendarData: PropTypes.array.isRequired,
      calendarMeta: PropTypes.shape({
        count: PropTypes.number,
      }).isRequired,
      addCalendarEvent: PropTypes.func.isRequired,
      updateCalendarEvent: PropTypes.func.isRequired,
      removeCalendarEvent: PropTypes.func.isRequired,
    },
    exposeProps: [
      `groupsCache`,
      `items`,
      `totalCount`,
      `handleEventAdd`,
      `handleEventRemove`,
      `handleEventEdit`,
    ],
  },
  compose(
    withPropsOnChange(
      [`calendarData`],
      ({ calendarData, calendarMeta: { count }, planId }) => {
        const { items, groups } = prepareCalendarData({
          calendarData,
          inPlan: Boolean(planId),
        })

        return {
          totalCount: String(count),
          items,
          groupsCache: groups,
        }
      },
    ),
    withHandlers({
      handleEventAdd: ({ addCalendarEvent }) => (event, resources) => {
        addCalendarEvent(event, resources)
      },
      handleEventEdit: ({ updateCalendarEvent }) => event => {
        updateCalendarEvent(event)
      },
      handleEventRemove: ({ removeCalendarEvent }) => event => {
        removeCalendarEvent(event)
      },
    }),
  ),
)
